module.exports = __webpack_public_path__ + "5783f2d41dcc2440d746919e5ea9a0d8.pdf";